module.exports = __webpack_public_path__ + "static/media/download-16.175c61f9.svg";